<template>
  <div class="arc-sec">
    <div class="cols">
      <div class="col">
        <div class="head"><h4>{{ $t('ARC_MGMT.VALUE.CATEGORIES') }}</h4>
          <button class="btn sm" type="button" @click="addCategory">+ {{ $t('ARC_MGMT.ADD') }}</button></div>
        <table>
          <tbody>
            <tr v-for="c in categories" :key="c.id">
              <td><span class="pl" :class="c.pilar">{{ c.pilar }}</span> {{ c.nome }}</td>
              <td class="acts"><button class="link danger" type="button" @click="delCategory(c)">{{ $t('ARC_MGMT.DELETE') }}</button></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col">
        <div class="head"><h4>{{ $t('ARC_MGMT.VALUE.ENTRIES') }} · {{ money(total) }}</h4>
          <button class="btn sm primary" type="button" @click="openNew" :disabled="!categories.length">+ {{ $t('ARC_MGMT.ADD') }}</button></div>
        <table>
          <thead><tr><th>{{ $t('ARC_MGMT.INDICATORS.M') }}</th><th>{{ $t('ARC_MGMT.VALUE.CATEGORY') }}</th><th>{{ $t('ARC_MGMT.VALUE.AMOUNT') }}</th><th /></tr></thead>
          <tbody>
            <tr v-for="e in entries" :key="e.id">
              <td>M{{ e.mes }}</td>
              <td>{{ catName(e.category_id) }}</td>
              <td>{{ money(e.valor) }}</td>
              <td class="acts"><button class="link danger" type="button" @click="delEntry(e)">{{ $t('ARC_MGMT.DELETE') }}</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="showModal" class="arc-modal-bg" @click.self="showModal = false">
      <div class="arc-modal">
        <h3>{{ $t('ARC_MGMT.VALUE.NEW_ENTRY') }}</h3>
        <div class="row">
          <label>{{ $t('ARC_MGMT.INDICATORS.M') }}<input v-model.number="entry.mes" type="number" min="1" max="12" /></label>
          <label>{{ $t('ARC_MGMT.VALUE.CATEGORY') }}
            <select v-model="entry.category_id"><option v-for="c in categories" :key="c.id" :value="c.id">{{ c.nome }}</option></select>
          </label>
          <label>{{ $t('ARC_MGMT.VALUE.AMOUNT') }}<input v-model.number="entry.valor" type="number" step="0.01" /></label>
        </div>
        <label>{{ $t('ARC_MGMT.VALUE.MEMO') }}<textarea v-model="entry.descricao" rows="2" /></label>
        <div class="modal-actions">
          <button class="btn" type="button" @click="showModal = false">{{ $t('ARC_MGMT.CANCEL') }}</button>
          <button class="btn primary" type="button" @click="saveEntry">{{ $t('ARC_MGMT.SAVE') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArcAPI from 'dashboard/api/arc';

export default {
  props: { journey: { type: Object, default: () => ({}) }, cycle: { type: [Number, String], default: null } },
  data() { return { categories: [], entries: [], total: 0, showModal: false, entry: {} }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      const [c, e] = await Promise.all([ArcAPI.valueCategories(), ArcAPI.valueEntries()]);
      this.categories = c.data.payload || [];
      this.entries = e.data.payload || [];
      this.total = e.data.total || 0;
    },
    money(v) { return 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 }); },
    catName(id) { const c = this.categories.find(x => x.id === id); return c ? c.nome : '—'; },
    async addCategory() {
      // eslint-disable-next-line no-alert
      const nome = window.prompt(this.$t('ARC_MGMT.VALUE.CATEGORY_NAME'));
      if (!nome) return;
      // eslint-disable-next-line no-alert
      const pilar = (window.prompt(this.$t('ARC_MGMT.VALUE.CATEGORY_PILLAR'), 'R') || 'R').toUpperCase();
      await ArcAPI.createValueCategory({ nome, pilar });
      this.load();
    },
    async delCategory(c) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(this.$t('ARC_MGMT.DELETE') + '?')) return;
      await ArcAPI.deleteValueCategory(c.id); this.load();
    },
    openNew() { this.entry = { mes: this.journey.mes_atual || 1, category_id: this.categories[0] && this.categories[0].id, valor: null, descricao: '' }; this.showModal = true; },
    async saveEntry() {
      await ArcAPI.createValueEntry(this.entry);
      this.showModal = false; this.load(); this.$emit('refresh');
    },
    async delEntry(e) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(this.$t('ARC_MGMT.DELETE') + '?')) return;
      await ArcAPI.deleteValueEntry(e.id); this.load(); this.$emit('refresh');
    },
  },
};
</script>

<style lang="scss" scoped>
.cols { display: grid; grid-template-columns: 1fr 1.4fr; gap: var(--space-large); }
@media (max-width: 900px) { .cols { grid-template-columns: 1fr; } }
.head { display: flex; justify-content: space-between; align-items: center; margin-bottom: var(--space-small);
  h4 { font-size: var(--font-size-small); color: var(--s-700); margin: 0; } }
table { width: 100%; border-collapse: collapse; }
th { text-align: left; font-size: var(--font-size-mini); color: var(--s-400); padding: var(--space-smaller) var(--space-small); border-bottom: 1px solid var(--s-100); }
td { padding: var(--space-small); border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-800); }
.pl { display: inline-grid; place-items: center; width: 1.6rem; height: 1.6rem; border-radius: var(--border-radius-normal); font-weight: var(--font-weight-bold); font-size: var(--font-size-mini);
  &.A { background: #E6F1FC; color: #1E88E5; } &.R { background: #E7F6EE; color: #1F9D63; } &.C { background: #EFECFF; color: #7B61FF; } }
.acts { text-align: right; }
.link { border: 0; background: none; color: var(--w-600); font-size: var(--font-size-mini); cursor: pointer; &.danger { color: var(--r-500); } }
.btn { height: var(--space-large); padding: 0 var(--space-normal); border-radius: var(--border-radius-normal); border: 1px solid var(--s-200); background: var(--white); color: var(--s-700); font-weight: var(--font-weight-medium); cursor: pointer;
  &.sm { height: var(--space-medium); font-size: var(--font-size-mini); padding: 0 var(--space-small); } &.primary { background: var(--w-500); border-color: var(--w-500); color: var(--white); } }
.arc-modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: grid; place-items: center; z-index: 9999; }
.arc-modal { background: var(--white); border-radius: var(--border-radius-large); padding: var(--space-large); width: 32rem; max-width: 92vw;
  h3 { margin: 0 0 var(--space-normal); color: var(--s-900); }
  label { display: flex; flex-direction: column; gap: var(--space-smaller); font-size: var(--font-size-small); color: var(--s-700); margin-bottom: var(--space-small); }
  input, textarea, select { border: 1px solid var(--s-200); border-radius: var(--border-radius-normal); padding: var(--space-smaller) var(--space-small); background: var(--white); color: var(--s-800); }
  .row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: var(--space-small); } }
.modal-actions { display: flex; justify-content: flex-end; gap: var(--space-small); margin-top: var(--space-normal); }
</style>
